import { ApiBase } from "../api.js";
import type { 
    LoginBody, 
    LoginResponse, 
    CheckEmailBody, 
    CheckEmailResponse, 
    ResetPasswordBody,
    SendSetupEmailBody,
    SetupEmailResponse,
    GetUserSetupInfoResponse
} from "../types/api/auth.js";

export class ApiAuth extends ApiBase {
    async login(data: LoginBody): Promise<LoginResponse> {
        const result = await this.api.post('/auth/login', data);
        return result.data;
    }

    async logout(): Promise<LoginResponse> {
        const result = await this.api.get('/users/logout');
        return result.data;
    }

    async checkEmail(data: CheckEmailBody): Promise<CheckEmailResponse> {
        const result = await this.api.post('/auth/check-email', data);
        return result.data;
    }

    async resetPassword(data: ResetPasswordBody): Promise<{ message: string }> {
        const result = await this.api.post('/auth/reset-password', data);
        return result.data;
    }

    async sendSetupEmail(data: SendSetupEmailBody): Promise<SetupEmailResponse> {
        const result = await this.api.post('/auth/send-setup-email', data);
        return result.data;
    }

    async getUserSetupInfo(userId: string): Promise<GetUserSetupInfoResponse> {
        const result = await this.api.get(`/auth/user-setup-info/${userId}`);
        return result.data;
    }
}   
